interface Props {
  message?: string;
}

export function LoadingState({ message = 'Loading…' }: Props) {
  return (
    <div className="page-loading">
      <div className="spinner" aria-hidden />
      <p>{message}</p>
    </div>
  );
}
